import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CountryInterface } from '../models/country.interface';
import { DepartmentInterface } from '../models/department.interface';

@Injectable()
export class CountryService {

  constructor(private apiService: ApiService) {}

  /**
   * Get countries
   */
  get(): Observable<Array<CountryInterface>> {
    return this.apiService.post('vitrine/countries', {});
  }

  /**
   * Get France Departments
   */
  getDepartments(): Observable<Array<DepartmentInterface>> {
    return this.apiService.get('vitrine/departments');
  }

}
